<template>
  <div>
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="box-header">
        <span class="box-header__title">Список пациентов</span>
<!--         <el-button class="box-header__button" size="mini" @click="addUser" type="primary">Добавить</el-button>-->
        <el-input
          size="small"
          placeholder="Поиск по имени / ID / телефону..."
          class="box-header__search">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>

      <template>
        <el-table :data="tableData" class="table">
          <el-table-column prop="id" label="id" width="50"></el-table-column>
          <el-table-column  label="Имя" >
            <template slot-scope="scope">
             <div class="table__name">{{ scope.row.name }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="age" label="Возраст"/>
          <el-table-column prop="phone" label="Телефон"/>
          <el-table-column fixed="right" align="center" width="140" label="Действия">
            <template slot-scope="scope">
              <el-tooltip content="Просмотр" placement="top">
                <el-button
                  class="table__btn"
                  size="mini"
                  type="primary"
                  icon="el-icon-view"
                  circle
                  @click="editUser(scope.row.id, scope.row)"
                />
              </el-tooltip>
              <el-tooltip content="Удалить пациента" placement="top">
                <el-popconfirm
                  class="confirmBtn"
                  @onConfirm="deleteUser(scope.row.id, scope.$index)"
                  title="Вы уверены?"
                  confirmButtonText="Да"
                  confirmButtonType="danger"
                  cancelButtonType="default"
                  cancelButtonText="Нет"
                >
                  <el-button
                    size="mini"
                    icon="el-icon-delete"
                    circle
                    class="table__btn"
                    slot="reference"
                    type="danger"
                  />
                </el-popconfirm>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          v-if="showPagination"
          class="pagination"
          background
          layout="prev, pager, next"
          :page-size="pagination.per_page"
          :total="pagination.total"
          :current-page="pagination.current_page"
          @current-change="loadLogic"
        ></el-pagination>

      </template>
      <div class="error-load" v-if="errorLoadCard">
        <p>Ошибка загрузки</p>
        <el-button type="danger" @click="loadLogic">Загрузить еще раз</el-button>
      </div>
    </el-card>

    <user-edit
      :visible="workerEditModal"
      @close="workerEditModal = false"
      @update="loadLogic"
      :user="selectUser"
    />

  </div>
</template>

<script>
import UserEdit from '@/components/dialog/user/Show'

export default {
  name: 'Users',
  data () {
    return {
      tableData: null,
      loading: false,
      errorLoadCard: false,
      User: {
        title: null,
        description: null
      },
      error: null,
      cardId: null,
      selectUser: false,
      workerAddModal: false,
      workerEditModal: false,
      pagination: null
    }
  },
  created () {
    this.loadLogic()
  },
  computed: {
    showPagination () {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page
      } else return false
    }
  },
  components: { UserEdit },
  methods: {
    loadLogic (page = 1) {
      this.loading = !!1

      const params = {
        params: {
          page
        }
      }

      this.$api.users
        .getList(params)
        .then((response) => {
          this.tableData = response.data.data
          if (response.data.meta) this.pagination = response.data.meta.pagination
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки списка',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })
    },
    editUser (id) {
      this.selectUser = id
      this.workerEditModal = !!1
    },
    addUser () {
      this.workerAddModal = !!1
    },
    deleteUser (id, idIndex) {
      this.loading = !!1
      this.$api.worker
        .delete(id)
        .then((response) => {
          this.loadData = response.data
          this.$notify.success({
            title: 'Успешно',
            message: 'Анкета удалена'
          })
          this.tableData.splice(idIndex, 1)
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка авторизации',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })
    }
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 1960px;
  margin: 0 auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.table {
  width: 100%;

  &__name {

    color: #5AC9AD;

  }
  &__btn {
    margin: 5px;
  }
}

.box-header {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 10px;

  &__title {
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;

    color: #303133;
  }

  &__search {
    width: 260px;
  }

}
.pagination {
  margin-top: 10px;
  padding: 0;
}
</style>
